import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DeprecatedConfirmationDialogComponent } from '@app/components';
import { AnalyticEvents, FeatureFlag } from '@app/enums';
import { TemplateType } from '@app/modules/performance/enums/template-type.enum';
import { ReviewService } from '@app/modules/performance/services';
import { AnalyticService } from '@app/services';
import { FeatureService } from '@app/services/feature.service';
import { NotifyService } from '@app/services/notify.service';
import { ShowView } from '@common/views';
import { TemplateBuilderComponent } from '@performance/components/template-builder/template-builder.component';

@Component({
    templateUrl: './template-show.template.html',
    styleUrls: ['./template-show.style.scss'],
})
export class TemplateShowView extends ShowView implements OnInit {
    @ViewChild(DeprecatedConfirmationDialogComponent, { static: true })
    confirmDelete: DeprecatedConfirmationDialogComponent;
    @ViewChild('templateBuilderComponent', { static: true }) templateBuilderComponent: TemplateBuilderComponent;

    /**
     * Loading Indicator
     */
    isLoading = true;
    template: any = {};
    isDirty = false;
    performanceReviewImprovements = false;
    templateTypes = TemplateType;

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private analyticService: AnalyticService,
        private notify: NotifyService,
        private featureService: FeatureService,
        private reviewService: ReviewService
    ) {
        super();
        this.template = this.route.snapshot.data.models.get('template');
    }

    async ngOnInit(): Promise<void> {
        this.performanceReviewImprovements = await this.featureService.has(FeatureFlag.performanceReviewImprovements);
        this.isLoading = false;
    }

    onSave(): void {
        this.isLoading = true;
        this.template
            .save()
            .then(() => {
                this.notify.success('performance.template-show.saved');
                this.isLoading = false;
            })
            .catch((err) => {
                this.notify.error(err.message || 'performance.template-show.couldNotSave');
                this.isLoading = false;
            });
    }

    onCancel(): void {
        this.template.revert();
    }

    cloneAndRedirectToTemplate(): void {
        this.isLoading = true;

        this.reviewService.cloneAndRedirectToTemplate(this.template, () => {
            this.isLoading = false;
        });
    }

    onDelete(): void {
        this.confirmDelete.show().then((confirm) => {
            if (confirm) {
                this.isLoading = true;
                this.template
                    .delete()
                    .then(() => {
                        this.notify.success('performance.template-show.deletedOk');
                        this.router.navigate(['../'], { relativeTo: this.route });

                        this.analyticService.trackEvent(AnalyticEvents.SurveysDeleteTemplateConfirm);
                    })
                    .catch((err) => {
                        this.notify.error(err);
                        this.isLoading = false;
                    });
            }
        });
    }

    launch(): void {
        this.templateBuilderComponent.launch();
    }

    save(): Promise<any> {
        return this.template
            .save()
            .then(() => {
                this.notify.success('performance.templates.templateSaved');
                this.analyticService.trackEvent(AnalyticEvents.SurveysEditTemplateAutoSave);
            })
            .catch((err) => {
                this.notify.error(err);
                this.isLoading = false;
            });
    }
}
